import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import * as Yup from 'yup';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  Paper,
  MenuItem,
  Input,
  InputAdornment,
  IconButton,
  Backdrop,
  CircularProgress,
  Stack,
  Divider,
  TextField
} from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/Receipt';
import SearchIcon from '@material-ui/icons/Search';
import { useFormik, Form, FormikProvider } from 'formik';
import { baseUrl, claimType, retirementType, employers, currencies } from '../../utils/constants';
import { useClientContext } from '../../context/client_context';
import { useClaimsContext } from '../../context/claims_context';
import { useConstantsContext } from '../../context/constants_context';
import Controls from '../controls/Controls';
import ClaimSubform from './ClaimSubform';
import ClaimsDocs from './ClaimsDocs';
import ClaimsLineInit from './ClaimsLineInit';
import { DocumentList } from '../uploads/DocumentList';

export default function Claims() {
  const { bankBranches, banks, payCycles } = useConstantsContext();
  const { setCurrentClaim, currentClaim, claimNo, currentBatch, setClaimNo, clearLineItem } =
    useClaimsContext();
  const { dependantList, setDependantList } = useClientContext();
  const [branchList, setBranchList] = useState([
    {
      refId: 0,
      name: 'No Bank Selected'
    }
  ]);
  const [memberCode, setMemberCode] = useState('');
  const [claimFilter, setClaimFilter] = useState('new');
  const [memberSearchName, setSearchName] = useState('');
  const [mainMember, setMainMember] = useState({});
  const [switchChecked, setSwitchChecked] = useState(currentClaim.self_Payment);
  const [loading, setLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupDiag, setOpenPopupDiag] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });

  useEffect(() => {
    getClaimById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependantList]);

  useEffect(() => {
    console.log('currentClaim.self_Payment', currentClaim.self_Payment);
    setSwitchChecked(currentClaim.self_Payment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClaim]);

  useEffect(() => {
    if (currentClaim.parent_Cif) populateDependants(currentClaim.parent_Cif);
    setSwitchChecked(currentClaim.self_Payment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClaim.parent_Cif]);

  currentClaim.dateCreated = moment(currentClaim.dateCreated).format('yyyy-MM-DD');

  const ClaimsSchema = Yup.object().shape({
    pay_Cycle_Date: Yup.number().required('you must specify the Transacting Month'),
    dateCreated: Yup.date().required('you must specify the Date of Creation'),
    service_Type_id: Yup.number()
      .required('Claim Type is required')
      .moreThan(0, 'Claim Type has not been updated'),
    cif_Number: Yup.number()
      .required('Patient is required')
      .moreThan(0, 'Patient has not been selected'),
    currencyId: Yup.number()
      .required('Currency is required')
      .moreThan(0, 'Currency has not been selected'),
    medFundNumber: Yup.string()
      .min(2, 'Member Fund # is too Short!')
      .max(8, 'Member Fund # is too Long!')
      .required('Member Fund # required'),
    claimantMobile: Yup.string().required('Claimant Mobile is Required'),
    claimantForename: Yup.string().required('Claimant Forename is Required'),
    claimantSurname: Yup.string().required('Claimant Surname is Required'),
    claimantIdNumber: Yup.string().required('Claimant IdNumber is Required'),
    claimantRelation: Yup.string().required('Claimant Relation is Required')
  });

  const formik = useFormik({
    initialValues: currentClaim,
    enableReinitialize: true,
    validationSchema: ClaimsSchema,
    onSubmit: (values) => {
      console.log('values found', values);
      if (values.service_Type_id === 1) {
        values.dependantId = 0;
        values.circumstance = '';
        delete values.dateOfDeath;
      }
      if (values.service_Type_id === 2) {
        values.dependantId = 0;
        values.retirementTypeId = 0;
        delete values.retirementDate;
        // values.retirementDate = '';
      }
      if (values.service_Type_id === 3 || values.service_Type_id === 4) {
        values.retirementTypeId = 0;
        values.retirementDate = '';
        delete values.retirementDate;
        if (
          values.dependantId === null ||
          values.dependantId === null ||
          values.dependantId === ''
        ) {
          notifyPopup(`Child or Spouse not Selected, please select and try saving again!`, 'error');
          return;
        }
      }
      if (values.cif_Number === '') {
        notifyPopup(`Patient # not Selected, please select Patient!`, 'error');
      } else {
        saveClaim(values);
      }
    }
  });

  // const { submitForm } = formik;

  // const handleSubmit = () => {
  //   submitForm();
  // };

  const getMemberInfo = async (event) => {
    if (memberCode === '') {
      notifyPopup(`No Employee # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    // populateProviders(currentBatch.provider_Id);
    await axios(`${baseUrl}/api/client/GetMembersByFundNo?medFundNo=${memberCode}`).then(
      (result) => {
        if (result.replyStatus === 1) {
          notifyPopup(`Member not Found!: ${result.replyMessage}`, 'error');
        } else if (result.data.result.length === 0) {
          notifyPopup(`Member not Found! Please enter correct Member #`, 'error');
        } else {
          // setDependantList(result.data.result);
          console.log('result.data.result', result.data.result);
          populateDependants(result.data.result[0].cif_number);
          setMainMember(result.data.result[0]);
          formik.setFieldValue('parent_Cif', result.data.result[0].cif_number);
          formik.setFieldValue('cif_Number', result.data.result[0].cif_number);
          formik.setFieldValue('medFundNumber', result.data.result[0].memberShipNo);
          formik.setFieldValue('scheme_id', result.data.result[0].principalSchemeID);
          formik.setFieldValue('memberType_id', result.data.result[0].memberType_ID);
          formik.setFieldValue('group_id', result.data.result[0].group_id);
          setSearchName(`${result.data.result[0].surname} ${result.data.result[0].firstName}`);
          const date1 = moment(result.data.result[0].dateOfBirth);
          const date2 = moment();
          const diff = date2.diff(date1, 'years');
          formik.setFieldValue('currentAge', diff);

          formik.setFieldValue('batchID', currentBatch.batchID);
          formik.setFieldValue('provider_Id', currentBatch.provider_Id);
          formik.setFieldValue('pay_Cycle_Date', currentBatch.payCycleId);
          formik.setFieldValue('status_Id', currentBatch.batchStatus_Id);
          formik.setFieldValue('workStation', window.location.hostname);
          // formik.setFieldValue('currencyId', 3);
          formik.setFieldValue('userId', sessionStorage.getItem('oldRefId'));
          if (currentBatch.isSelfPayment) {
            setSwitchChecked(!switchChecked);
            formik.setFieldValue('self_Payment', !switchChecked);
          }

          setLoading(false);
        }
      },
      (error) => {
        notifyPopup(`Error in getMemberInfo!: ${error}`, 'error');
      }
    );
  };

  const populateDependants = async (cifNumber) => {
    if (cifNumber === '') {
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetDependentsByParentCif?cifNumber=${cifNumber}`).then(
      (result) => {
        console.log('dependantss', result);
        setLoading(false);
        if (result.data.result.length === 0) {
          notifyPopup(`No Dependants Found for Member!: ${result.replyMessage}`, 'error');
        } else {
          setDependantList(result.data.result);
          // setSearchName(`${result.data.result[0].surname} ${result.data.result[0].firstName}`);
          // setMainMember(result.data.result[0]);
        }
      },
      (error) => {
        notifyPopup(`Error in populateDependants!: ${error}`, 'error');
      }
    );
  };

  const getClaimById = async (event) => {
    if (claimNo === -1) {
      return;
    }
    if (claimNo === 0) {
      // setCurrentClaim({});
      return;
    }
    setLoading(true);

    await axios(`${baseUrl}/api/claims/getClaimById?claimId=${claimNo}`).then(
      (result) => {
        setLoading(false);
        setCurrentClaim(result.data.result);
      },
      (error) => {
        notifyPopup(`Error in Getting Claim!: ${error}`, 'error');
      }
    );
  };

  const memberStateEnquiry = async (e) => {
    formik.setFieldValue('cif_Number', e);
    setLoading(true);

    await axios(`${baseUrl}/api/client/memberStateEnquiry?cif_number=${e}`).then(
      (result) => {
        setLoading(false);
        if (result.data.result === undefined || result.data.result === null)
          notifyPopup(`Client Terminated or Not Qualifying.  Claim will not be honoured`, 'error');
      },
      (error) => {
        notifyPopup(`Error in Member Query: ${error}`, 'error');
      }
    );
  };

  const saveClaim = async (client) => {
    setLoading(true);
    const jsonClient = [];
    jsonClient.push(client);
    console.log('claims stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/claims/saveClaim`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (res) => {
          console.log('returned claim', res);
          setLoading(false);
          setCurrentClaim(res);
          setClaimNo(res.claim_ID);
          notifyPopup(`Claim Saved Successfully!`, 'success');
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Saving Claim!: ${error}`, 'error');
        }
      );
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const closePopup = () => {
    setOpenPopup(false);
  };

  const closePopupDiag = () => {
    setOpenPopupDiag(false);
  };

  const newLine = () => {
    clearLineItem();
    setOpenPopupDiag(true);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const { errors, touched } = formik;

  /* eslint-disable camelcase */
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Typography component="span" variant="h6" gutterBottom>
          Process Claim
        </Typography>
        <Card
          sx={{
            m: '30px 100px'
          }}
        >
          <CardContent>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
              onClick={handleLoadingClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={2}>
              <Grid item xs={8} sm={8}>
                <Paper>
                  <Grid mb={2} container spacing={2}>
                    <Grid item xs={3} sm={3} mr={2}>
                      <FormControl>
                        <InputLabel htmlFor="memberCodem">Search Member</InputLabel>
                        <Input
                          id="memberCode"
                          type="text"
                          value={memberCode}
                          onChange={(e) => {
                            setMemberCode(e.target.value);
                          }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onMouseDown={handleMouseDownPassword}
                                onClick={() => getMemberInfo()}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <FormControl fullWidth>
                        <InputLabel htmlFor="memberSearchName">Member Name</InputLabel>
                        <Input
                          id="memberSearchName"
                          type="text"
                          value={memberSearchName}
                          disabled
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={3} sm={5}>
                      <Controls.Input name="medFundNumber" label="EC #" disabled />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <Controls.SelectJson name="group_id" label="Province" options={employers} />
                    </Grid>
                    {/* <Grid item xs={4} sm={5}>
                      <FormControl fullWidth>
                        <InputLabel id="patientlbl">Claim for: </InputLabel>
                        <Select
                          id="cif_Number"
                          value={formik.values.cif_Number}
                          name="cif_Number"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            memberStateEnquiry(e.target.value);
                          }}
                          error={Boolean(touched.cif_Number && errors.cif_Number)}
                          helperText={touched.cif_Number && errors.cif_Number}
                        >
                          <MenuItem key="" value="">
                            Not Selected
                          </MenuItem>
                          {dependantList.map((item) => (
                            <MenuItem key={item.cif_number} value={item.cif_number}>
                              {item.suffix} {item.surname} {item.firstName}{' '}
                              {moment(item.dateOfBirth).isValid()
                                ? moment(item.dateOfBirth).format('YYYY-MM-DD')
                                : ''}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid> */}
                    <Grid item xs={12} sm={8}>
                      <FormControl fullWidth>
                        <InputLabel id="sertxt">Service Type</InputLabel>
                        <Select
                          id="service_Type_id"
                          value={formik.values.service_Type_id}
                          name="service_Type_id"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('service_Type_id', e.target.value);
                            if (e.target.value === 1 || e.target.value === 3) {
                              formik.setFieldValue('claimantSurname', mainMember.surname);
                              formik.setFieldValue('claimantForename', mainMember.firstName);
                              formik.setFieldValue('claimantMobile', mainMember.cellNumber ?? '');
                              formik.setFieldValue('claimantIdNumber', mainMember.idNumber);
                              formik.setFieldValue('claimantRelation', 'Self');
                              formik.setFieldValue(
                                'accountName',
                                `${mainMember.surname} ${mainMember.firstName}`
                              );
                            } else {
                              formik.setFieldValue('claimantSurname', '');
                              formik.setFieldValue('claimantForename', '');
                              formik.setFieldValue('claimantMobile', '');
                              formik.setFieldValue('claimantIdNumber', '');
                              formik.setFieldValue('claimantRelation', '');
                              formik.setFieldValue('accountName', '');
                            }
                          }}
                          error={Boolean(touched.service_Type_id && errors.service_Type_id)}
                          helpertext={touched.service_Type_id && errors.service_Type_id}
                        >
                          <MenuItem key="" value="">
                            Not Selected
                          </MenuItem>
                          {claimType.map((item) => (
                            <MenuItem key={item.refId} value={item.refId}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {formik.values.service_Type_id === 2 && (
                      <Grid item xs={12} sm={10}>
                        <Controls.Input
                          name="circumstance"
                          label="Circumstance leading to death"
                          multiline
                          rows={2}
                        />
                      </Grid>
                    )}
                    {formik.values.service_Type_id > 1 && (
                      <Grid item xs={12} sm={5}>
                        <Controls.DateTime name="dateOfDeath" label="Date of Death" />
                      </Grid>
                    )}
                    {formik.values.service_Type_id === 1 && (
                      <Grid item xs={12} sm={5}>
                        <Controls.SelectJson
                          name="retirementTypeId"
                          label="Retirement Type"
                          options={retirementType}
                        />
                      </Grid>
                    )}
                    {formik.values.service_Type_id === 1 && (
                      <Grid item xs={12} sm={5}>
                        <Controls.DateTime name="retirementDate" label="Date of Retirement" />
                      </Grid>
                    )}
                    {formik.values.service_Type_id > 2 && (
                      <Grid item xs={4} sm={5}>
                        <FormControl fullWidth>
                          <InputLabel id="deplbl">Dependant: </InputLabel>
                          <Select
                            id="dependantId"
                            value={formik.values.dependantId}
                            name="dependantId"
                            fullWidth
                            size="small"
                            variant="outlined"
                            onChange={(e) => {
                              formik.setFieldValue('dependantId', e.target.value);
                              // memberStateEnquiry(e.target.value);
                            }}
                            error={Boolean(touched.dependantId && errors.dependantId)}
                            helpertext={touched.dependantId && errors.dependantId}
                          >
                            <MenuItem key="" value="">
                              Not Selected
                            </MenuItem>
                            {dependantList.map((item) => (
                              <MenuItem key={item.cif_number} value={item.cif_number}>
                                {item.suffix} {item.surname} {item.firstName}{' '}
                                {moment(item.dateOfBirth).isValid()
                                  ? moment(item.dateOfBirth).format('YYYY-MM-DD')
                                  : ''}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}
                  </Grid>
                </Paper>
                <Divider
                  style={{
                    background: '#1a237e',
                    height: 2,
                    margin: 10,
                    width: '80%',
                    paddingTop: 4
                  }}
                  variant="middle"
                />
                <Grid item xs={12} sm={12}>
                  {/* <Paper variant="outlined"> */}
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                      <Controls.Input name="claimantSurname" label="Claimant Surname" />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <Controls.Input name="claimantForename" label="Claimant Forename" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="claimantMobile" label="Claimant Phone" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="claimantIdNumber" label="Claimant Id #" />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Controls.Input name="claimantRelation" label="Relationship" />
                    </Grid>
                  </Grid>
                  {/* </Paper> */}
                  <Divider
                    style={{
                      background: '#1a237e',
                      height: 2,
                      margin: 10,
                      width: '80%',
                      paddingTop: 4
                    }}
                    variant="middle"
                  />
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="bankRefIdLabel">Bank</InputLabel>
                        <Select
                          id="bankRefId"
                          value={formik.values.bankRefId}
                          name="bankRefId"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('bankRefId', e.target.value);
                            setBranchList(
                              bankBranches.filter((m) => m.bankRefId === e.target.value)
                            );
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {banks.map((item) => (
                            <MenuItem key={item.refId} value={item.refId}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="bankBranchRefIdLabel">Bank Branch</InputLabel>
                        <Select
                          id="bankBranchRefId"
                          value={formik.values.bankBranchRefId}
                          name="bankBranchRefId"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('bankBranchRefId', e.target.value);
                            const tempCurr = branchList.filter(
                              (item) => item.refId === e.target.value
                            );
                            formik.setFieldValue('sortCode', tempCurr[0].branchCode);
                            console.log('e.target.value', e.target.value);
                            console.log('tempCurr', tempCurr[0].branchCode);
                            console.log('branchList', branchList);
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {branchList.map((item) => (
                            <MenuItem key={item.refId} value={item.refId}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Controls.Input name="sortCode" label="Branch Code" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="accountNumber" label="Account #" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="accountName" label="Account Name" />
                    </Grid>
                    {/* </Paper>
                    </Grid> */}
                  </Grid>
                  {/* </Paper> */}
                </Grid>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper variant="outlined" mt={2}>
                  <Grid item xs={12} sm={12} margin={2}>
                    <Controls.InputNumber name="claim_ID" label="Claim #" disabled />
                  </Grid>
                  <Grid item xs={12} sm={12} margin={2}>
                    <Controls.DateTime name="dateCreated" label="Date Created" />
                  </Grid>
                  <Grid item xs={12} sm={12} margin={2}>
                    <FormControl fullWidth>
                      <InputLabel id="payCycleLbl">Pay Period</InputLabel>
                      <Select
                        id="pay_Cycle_Date"
                        value={formik.values.pay_Cycle_Date}
                        name="pay_Cycle_Date"
                        fullWidth
                        size="small"
                        variant="outlined"
                        onChange={(e) => {
                          formik.setFieldValue('pay_Cycle_Date', e.target.value);
                        }}
                      >
                        <MenuItem key="" value="">
                          Not Selected
                        </MenuItem>
                        {payCycles.map((item) => (
                          <MenuItem key={item.payCycleId} value={item.payCycleId}>
                            {moment(item.payDate).format('YYYY-MM-DD')}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12} margin={2}>
                    <TextField
                      id="currency"
                      select
                      size="small"
                      fullWidth
                      value={formik.values.currencyId}
                      onChange={(e) => {
                        console.log('target.value', e.target.value);
                        formik.setFieldValue('currencyId', e.target.value);
                        formik.setFieldValue('payoutMethod', e.target.value);
                      }}
                      error={Boolean(touched.currencyId && errors.currencyId)}
                      helpertext={touched.currencyId && errors.currencyId}
                    >
                      <MenuItem key="" value="0">
                        Select Currency
                      </MenuItem>
                      {currencies.map((option) => (
                        <MenuItem key={option.refId} value={option.refId}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  {/* <Grid item xs={4} sm={12} margin={2}>
                    <FormControl>
                      <FormControlLabel
                        control={
                          <Switch
                            name="self_Payment"
                            value={formik.values.self_Payment}
                            size="small"
                            checked={switchChecked}
                            onChange={(e) => {
                              setSwitchChecked(!switchChecked);
                              formik.setFieldValue('self_Payment', !switchChecked);
                            }}
                          />
                        }
                        label="Cash Paying"
                      />
                    </FormControl>
                  </Grid> */}
                </Paper>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} m={2}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb="3">
                <Button
                  type="submit"
                  variant="outlined"
                  color="secondary"
                  startIcon={<ReceiptIcon />}
                  // onClick={() => handleSubmit()}
                >
                  Save Claim
                </Button>
                {/* <Button
                  type="button"
                  variant="outlined"
                  color="primary"
                  disabled={formik.values.claim_ID < 1}
                  startIcon={<LocalHospitalIcon />}
                  onClick={() => newLine()}
                >
                  Add Documents
                </Button> */}
                <Button
                  type="button"
                  variant="outlined"
                  color="secondary"
                  startIcon={<ReceiptIcon />}
                  disabled={formik.values.claim_ID < 1 || formik.values.status_Id === 5}
                  onClick={() => setOpenPopup(true)}
                >
                  Add Services
                </Button>
              </Stack>
            </Grid>
            <Controls.Notification notify={notify} setNotify={setNotify} />
            <Controls.ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
            <Controls.Popup
              title="Add Detail Line"
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
            >
              <ClaimsLineInit
                closePopup={closePopup}
                claim_ID={claimNo}
                service_Type_Id={currentClaim.service_Type_id}
              />
            </Controls.Popup>
            <Controls.Popup
              title="Add Documents"
              openPopup={openPopupDiag}
              setOpenPopup={setOpenPopupDiag}
            >
              <ClaimsDocs
                closePopup={closePopupDiag}
                claimId={claimNo}
                clientRefId={currentClaim.cif_Number}
              />
            </Controls.Popup>
          </CardContent>
        </Card>
        <ClaimSubform />
        <DocumentList refId={claimNo} />
      </Form>
    </FormikProvider>
  );
}
